import { Alert, AlertTitle, Box } from '@mui/material'

export function ChangingAccountantDocumentsAlert() {
  const previousYear = new Date().getFullYear() - 1
  const currentYear = new Date().getFullYear()

  return (
    <Alert icon={false} severity="info">
      <AlertTitle>Documentos para transferência de contador</AlertTitle>
      Lista de documentos necessários para a transferência definitiva de
      contador
      <Box
        component="ul"
        sx={{
          listStyle: 'inside',
          pl: 1,
          mt: 1,
          mb: 0,
          '& li': { fontSize: { xs: '14px', md: '16px' } },
        }}
      >
        <li>Balanço Patrimonial: referente ao ano de {previousYear}.</li>
        <li>
          Balanço Patrimonial: referente aos meses de {currentYear} anteriores
          ao início da nossa responsabilidade.
        </li>
        <li>DRE: referente ao ano de {previousYear}.</li>
        <li>
          DRE: referente aos meses de {currentYear} anteriores ao início da
          nossa responsabilidade.
        </li>
        <li>
          Balancete de Verificação: referente aos meses de {currentYear}{' '}
          anteriores ao início da nossa responsabilidade.
        </li>
        <li>
          Composição de Saldos: Imobilizado, Impostos a Recuperar e
          Adiantamento de Clientes (se houver).
        </li>
        <li>
          Memórias de Cálculo: apenas se a empresa for Lucro Presumido.
        </li>
        <li>Recibos de Pró-Labore: dos últimos 12 meses.</li>
      </Box>
    </Alert>
  )
}
